import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';
const ToggleMenuIcon = React.memo(
  ({
    fill = variables['colors-mc-text-primary'],
    fillOpacity = '0.3',
    fillNone = 'none',
    width = '24',
    viewBox = '0 0 24 24'
  }) => (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={remCss(width)}
        height={remCss(width)}
        viewBox={viewBox}
      >
        <defs></defs>
        <path fill={fillNone} d='M0,0H24V24H0Z' />
        <path
          fill={fill}
          d='M5.293-6.707a1,1,0,0,0,0,1.414,1,1,0,0,0,1.414,0l6-6a1,1,0,0,0,.03-1.383l-5.5-6a1,1,0,0,0-1.413-.062,1,1,0,0,0-.061,1.413l4.853,5.294Z'
          transform='translate(18) rotate(180)'
        />
        <path
          fill={fill}
          fillOpacity={fillOpacity}
          d='M10.707-15.707a1,1,0,0,0-1.414,0,1,1,0,0,0,0,1.414l6,6a1,1,0,0,0,1.383.03l6-5.5a1,1,0,0,0,.061-1.413,1,1,0,0,0-1.413-.061L16.03-10.384Z'
          transform='translate(4 -4) rotate(90)'
        />
      </svg>
    </>
  )
);
ToggleMenuIcon.displayName = 'ToggleMenuIcon';
export default ToggleMenuIcon;
